export default [
  {
    key: 'title',
    label: 'field.holidayTitle',
    type: 'text',
    rules: 'required|max:100',
  },
  {
    key: 'isRepeatEveryYear',
    label: 'field.type',
    type: 'radio',
    rules: 'required',
    options: [
      { text: 'field.applyOnce', value: false },
      { text: 'field.repeatAnnually', value: true },
    ],
    cols: 6,
  },
  {
    key: 'date',
    label: 'field.date',
    type: 'date',
    rules: 'required',
    min: new Date(new Date().setDate(new Date().getDate())),
  },
  {
    key: 'description',
    label: 'field.description',
    type: 'textarea',
  },
]
